import React from "react";
import { array, bool, string } from "prop-types";
import styles from "./styles/CourseSlider.module.css";
import { NextArrow, PrevArrow } from "@components/common";
import Slider from "react-slick";
import { CourseCard, CourseCardPlaceholder } from "@components/CourseCard";
import { Col, Row } from "react-bootstrap";
import { useWindowSize } from "@hooks";

const CourseSlider = ({ data, loading, courseType }) => {
  // state

  // variables
  let minimumCourseRequired = 3;
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };

  // logics before hooks

  // hooks
  const { width } = useWindowSize();

  // logics
  if (width <= 1024) minimumCourseRequired = 2;
  if (width <= 600) minimumCourseRequired = 1;

  const coursePlaceholderData = Array.from(Array(5).keys());

  const coursesData = data ?? [];

  // UI partials
  const coursesPlaceholder = coursePlaceholderData.map((key) => (
    <CourseCardPlaceholder key={key} />
  ));

  const courses = coursesData.map((item, index) => (
    <CourseCard key={index} data={item} type={courseType} />
  ));

  // effects

  // render
  if (!loading && coursesData.length <= minimumCourseRequired)
    return (
      <Row>
        {coursesData.map((item, index) => (
          <Col key={item.id || index} xs={12} sm={6} lg={4}>
            <CourseCard data={item} type={courseType} />
          </Col>
        ))}
      </Row>
    );
  return (
    <Slider {...settings} className={styles.slider}>
      {loading ? coursesPlaceholder : courses}
    </Slider>
  );
};

/* required: display name */
CourseSlider.displayName = "CourseSlider";

/* required: props types */
CourseSlider.propTypes = { data: array, loading: bool, courseType: string };

/* required: default props */
CourseSlider.defaultProps = { data: [], loading: true, courseType: "buy" };

export { CourseSlider };
